import * as types from './actionTypes';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';
import { Action } from 'redux';
import Terra from 'services/apis/terra/Terra';
import { ModuleIntegration } from 'data/terra/ModuleIntegration';
import { ModuleConfig } from 'data/terra/ModuleConfig';

export const fetchModuleIntegrations = (
  selectedAppVersionId?: string,
  selectedEnvId?: string
): ThunkAction<void, RootState, unknown, Action<string>> => async (
  dispatch,
  getState
) => {
  const {
    selectedApp,
    selectedAppVersion,
    selectedEnv,
  } = getState().appSelector;
  const appVersionId = selectedAppVersionId || selectedAppVersion?.id;
  const envId = selectedEnvId || selectedEnv?.id;

  const result = await Terra.moduleIntegration.fetchIntegrations(
    selectedApp?.id,
    appVersionId
  );

  if (result.isSuccess()) {
    const integrations = result.get()!.data;
    const integrationsOfSelectedEnv: ModuleIntegration[] = [];
    for (const i of integrations) {
      const configsResult = await Terra.moduleIntegration.fetchIntegrationConfigs(
        i.id
      );
      if (configsResult.isSuccess()) {
        if (
          configsResult
            .get()!
            .data.find((c: ModuleConfig<any, any>) => c.env.id === envId)
        ) {
          integrationsOfSelectedEnv.push(i);
        }
      }
    }

    dispatch({
      type: types.FETCH_MODULE_INTEGRATIONS_RESULT,
      integrations: integrations,
      integrationsOfSelectedEnv: integrationsOfSelectedEnv,
    } as types.FetchIntegrationResultAction);
  }
};
